<template>
	<svg :width="this.$props.width" :height="this.$props.height" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M20.0966 5.44336C20.4096 4.85212 21.2572 4.85212 21.5702 5.44336L36.5702 33.7764C36.8639 34.3312 36.4616 34.9997 35.8339 35H5.83386C5.20588 35 4.80273 34.3314 5.09656 33.7764L20.0966 5.44336ZM7.21765 33.333H34.4491L20.8339 7.61426L7.21765 33.333ZM21.6669 26.667V28.333H19.9999V26.667H21.6669ZM20.8339 15C21.2938 15.0003 21.6667 15.3731 21.6669 15.833V22.5C21.6669 22.9601 21.2939 23.3327 20.8339 23.333C20.3736 23.333 19.9999 22.9602 19.9999 22.5V15.833C20.0001 15.3729 20.3737 15 20.8339 15Z" :fill="this.$props.fill" />
	</svg>
</template>

<script>
export default {
  name: 'ExclamationTriangle',
  props: {
	width: {
	  type: [String, Number],
	  default: 40,
	},
	height: {
	  type: [String, Number],
	  default: 40,
	},
	fill: {
	  type: String,
	  default: 'white',
  	},
  },
};
</script>